import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import ApiKeySettings from 'modules/api_public/components/ApiKeySettings'
import CollectionsBootstrap from 'modules/api_public/lib/SettingsCollectionsBootstrap'
import { ApiKeyProvider, ApiKeys } from 'modules/api_public/store/collections/apiKeys'

const Container = () => {
  const collection = useLazyRef(() => new ApiKeys()).current
  const { value: canManageApiKeys } = useAsyncCan('api_keys.manage')

  return (
    <AuthorizeUser authorizeFn={() => canManageApiKeys}>
      <ApiKeyProvider collection={collection}>
        <ApiKeySettings />
      </ApiKeyProvider>
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
